// Built-in sample repositories (generated from the test fixtures by scripts/build-samples.mjs).
import type { SourceFileEntry } from '@modelviewer/core';
import type { WorkspaceSource } from './types';

export class SampleSource implements WorkspaceSource {
  readonly kind = 'sample' as const;
  readonly live = false;
  readonly id = 'sample:ef';

  private constructor(
    readonly label: string,
    private readonly files: Record<string, string>,
  ) {}

  static async load(): Promise<SampleSource> {
    const res = await fetch('/samples/ef-sample.json');
    if (!res.ok) throw new Error(`Could not load the sample (${res.status}).`);
    const data = (await res.json()) as { name: string; files: Record<string, string> };
    return new SampleSource(data.name, data.files);
  }

  async list(): Promise<SourceFileEntry[]> {
    return Object.keys(this.files)
      .sort()
      .map((path) => ({ path }));
  }

  async read(path: string): Promise<string> {
    const text = this.files[path];
    if (text === undefined) throw new Error(`File not found: ${path}`);
    return text;
  }
}
